module.exports = __webpack_public_path__ + "static/media/7-Clubs.7ffb6413.svg";